import React from "react";
import { Select, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import {
  Supplier,
  PurchaseStatus,
  PurchasePaymentStatus,
} from "../../../Types";

const { Option } = Select;

interface TopBarFieldProps {
  suppliers: Supplier[];
  setSupplierId: (v: string | null) => void;
  setPage: (p: number) => void;
  setStatus: (s: string | null) => void;
  setPaymentStatus: (p: string | null) => void;
  searchInput: string;
  setSearchInput: (s: string) => void;
}

export const TopBarField: React.FC<TopBarFieldProps> = ({
  suppliers,
  setSupplierId,
  setPage,
  setStatus,
  setPaymentStatus,
  searchInput,
  setSearchInput,
}) => {
  return (
    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
      <Select
        allowClear
        placeholder="Supplier Filter"
        onChange={(v) => {
          setSupplierId(v);
          setPage(1);
        }}
        className="w-full sm:w-40"
      >
        {suppliers?.map((s) => (
          <Option key={s.id} value={s.id}>
            {s.name}
          </Option>
        ))}
      </Select>

      <Select
        allowClear
        placeholder="Status Filter"
        onChange={(v) => {
          setStatus(v);
          setPage(1);
        }}
        className="w-full sm:w-36"
      >
        <Option value={PurchaseStatus.DRAFT}>Draft</Option>
        <Option value={PurchaseStatus.PENDING}>Pending</Option>
        <Option value={PurchaseStatus.COMPLETED}>Completed</Option>
        <Option value={PurchaseStatus.RETURNED}>Returned</Option>
      </Select>

      <Select
        allowClear
        placeholder="Payment Status"
        onChange={(v) => {
          setPaymentStatus(v);
          setPage(1);
        }}
        className="w-full sm:w-40"
      >
        <Option value={PurchasePaymentStatus.PAID}>Paid</Option>
        <Option value={PurchasePaymentStatus.PARTIAL}>Partial</Option>
        <Option value={PurchasePaymentStatus.DUE}>Due</Option>
      </Select>

      <Input
        placeholder="Search Invoice, PO, Supplier…"
        prefix={<SearchOutlined />}
        value={searchInput}
        onChange={(e) => {
          setSearchInput(e.target.value);
          setPage(1);
        }}
        allowClear
        onClear={() => {
          setSearchInput("");
          setPage(1);
        }}
        className="w-full sm:w-56"
      />
    </div>
  );
};
